import { format } from "date-fns";
import { id } from "date-fns/locale";

export function formatRelativeTime(timestamp: string): string {
  if (!timestamp) return "";

  const date = new Date(timestamp);
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInSeconds < 60) {
    return "baru saja";
  }

  if (diffInMinutes < 60) {
    return `${diffInMinutes} menit lalu`;
  }

  if (diffInHours < 24) {
    return `${diffInHours} jam lalu`;
  }

  if (diffInDays < 30) {
    return `${diffInDays} hari lalu`;
  }

  return format(date, "dd MMM yyyy", { locale: id });
}
